import { HStack, Skeleton, Text } from '@chakra-ui/react';

interface InventoryTotalValueCardProps {
    value?: number;
    isLoading?: boolean;
}

const formatCurrency = (v: number) =>
    new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(v);

/**
 * Live stock-$ KPI for the Inventory list toolbar (left of Add).
 * Height matches the `sm` Add button beside it, so value and label sit inline.
 */
export function InventoryTotalValueCard({
    value,
    isLoading = false,
}: InventoryTotalValueCardProps) {
    return (
        <HStack
            h={8}
            px={3}
            spacing={2}
            borderRadius="md"
            borderWidth="1px"
            borderColor="border.subtle"
            bg="white"
            flexShrink={0}
        >
            <Skeleton isLoaded={!isLoading} minW="64px" borderRadius="sm">
                <Text fontSize="sm" fontWeight="bold" color="fg.default" lineHeight="short">
                    {value !== undefined ? formatCurrency(value) : '—'}
                </Text>
            </Skeleton>
            <Text fontSize="xs" fontWeight="bold" color="fg.muted" whiteSpace="nowrap">
                IN-STOCK VALUE
            </Text>
        </HStack>
    );
}
